// Champ « J'ai un code » du panier (offre prix gris).
//
// Ce script est un fichier a part, et non un bloc « javascript » de snippet :
// la compilation de ces blocs par Shopify met 15 a 20 minutes a se generaliser,
// et sert entre-temps plusieurs versions differentes selon le visiteur. Sur un
// composant qui decide du montant paye, c'est inacceptable. Un fichier d'assets
// est publie immediatement.
//
// Appele a la fois par le layout et par le snippet lui-meme. Ce doublon est
// volontaire : les deux fichiers ne sortent pas du cache Shopify en meme temps,
// et pendant la transition les fiches produit se retrouvaient avec le champ
// affiche mais SANS script — bouton « Appliquer » inerte et validation partant
// au plein tarif. Le verrou ci-dessous rend les chargements suivants inoffensifs :
// les ecouteurs etant delegues au document, les poser deux fois provoquerait
// deux appels par clic, donc deux brouillons de commande.
(function () {
  if (window.__adCartPromoCharge) return;
  window.__adCartPromoCharge = true;

  // Deux instances coexistent sur une meme page : le tiroir (rendu partout) et
  // la page panier. Elles portent le MEME panier, donc le meme resultat : l'etat
  // est partage et vit dans cette portee, pas dans le DOM. C'est indispensable
  // car le tiroir est reconstruit entierement a chaque changement de quantite,
  // ce qui detruirait tout etat accroche aux elements.
  var resultat = null;

  // Le code saisi est memorise le temps de la visite, pour etre repris d'un
  // ecran a l'autre : le tiroir renvoie vers la page panier, et ce rechargement
  // effacerait sinon le code que le client vient de saisir.
  //
  // Seul le TEXTE du code est conserve, jamais le lien de paiement : ce lien
  // fige le panier et ne survit pas a une modification. Et il n'est jamais
  // rejoue tout seul au chargement — chaque appel cree un brouillon de commande
  // sur la boutique, on ne le declenche donc que sur une action du client.
  // Cle VERSIONNEE. La premiere version n'y rangeait que le code, en texte ; la
  // suivante y range une structure. Or Shopify sert les deux versions du script
  // en parallele pendant la propagation : l'ancienne relisait la structure comme
  // un code et recopiait le JSON entier dans le champ, sous les yeux du client.
  // Changer de cle rend les deux versions etanches.
  var CLE = 'ad-code-promo-v2';
  var CLE_ANCIENNE = 'ad-code-promo';

  // Duree de vie du resultat memorise. Les brouillons de commande ne vivent pas
  // eternellement cote ERP : au-dela, mieux vaut faire refaire le calcul que
  // renvoyer le client vers un lien mort.
  var VALIDITE_MS = 30 * 60 * 1000;

  // Signature du contenu du panier, independante de la page : la page panier et
  // le tiroir n'ont pas les memes formulaires, on ne peut donc pas comparer des
  // empreintes de formulaire d'un ecran a l'autre.
  var signatureLignes = function (lignes) {
    if (!lignes || !lignes.length) return '';
    var parts = [];
    for (var i = 0; i < lignes.length; i++) {
      parts.push(lignes[i].variantId + ':' + lignes[i].quantite);
    }
    return parts.sort().join('|');
  };

  // Un code promo reste court et sans ponctuation exotique. Ce controle est le
  // dernier rempart : quoi qu'il arrive en memoire, on ne recopie jamais dans le
  // champ autre chose que quelque chose qui ressemble a un code.
  var codeVraisemblable = function (code) {
    return typeof code === 'string' && code.length > 0 && code.length <= 64 && !/[{}"\s]/.test(code);
  };

  var memoriser = function (code, data, lignes) {
    try {
      sessionStorage.removeItem(CLE_ANCIENNE);
      if (!codeVraisemblable(code)) { sessionStorage.removeItem(CLE); return; }
      sessionStorage.setItem(CLE, JSON.stringify({
        code: code,
        url: data ? data.url : null,
        officiel: data ? data.totalOfficielCents : null,
        paye: data ? data.totalPayeCents : null,
        remisees: data ? data.lignesRemisees : null,
        total: data ? data.lignesTotal : null,
        signature: signatureLignes(lignes),
        horodatage: new Date().getTime()
      }));
    } catch (e) { /* navigation privee : on se passe de la reprise */ }
  };

  var memoire = function () {
    try {
      // Purge de l'ancienne cle : elle peut contenir la structure ecrite par une
      // version intermediaire, qu'une version plus ancienne afficherait telle quelle.
      sessionStorage.removeItem(CLE_ANCIENNE);
      var brut = sessionStorage.getItem(CLE);
      if (!brut) return null;
      var o = JSON.parse(brut);
      if (!o || !codeVraisemblable(o.code)) return null;
      if (o.horodatage && new Date().getTime() - o.horodatage > VALIDITE_MS) return null;
      return o;
    } catch (e) { return null; }
  };

  var codeMemorise = function () {
    var o = memoire();
    return o ? o.code : '';
  };

  // Empreinte des quantites telles qu'elles sont affichees dans un formulaire.
  // Sur la page panier, modifier une quantite ne recharge rien et ne declenche
  // aucun appel : sans cette comparaison au moment de valider, le client serait
  // envoye vers un lien de paiement correspondant a l'ancien panier et sa
  // modification serait perdue en silence.
  var empreinte = function (form) {
    if (!form) return '';
    var champs = form.querySelectorAll('input[name^="updates["]');
    var parts = [];
    for (var i = 0; i < champs.length; i++) {
      parts.push(champs[i].name + '=' + champs[i].value);
    }
    return parts.join('|');
  };

  // Les lignes envoyees a l'ERP sont lues dans le formulaire, pas dans le rendu
  // serveur : sur la page panier une quantite peut avoir ete modifiee sans
  // rechargement, et calculer la remise sur l'ancienne quantite donnerait un
  // montant a payer qui ne correspond pas au panier reel.
  // Le nom du champ vaut « updates[<idVariante>:<empreinte>] ».
  var lignesDepuisFormulaire = function (form) {
    if (!form) return null;
    var champs = form.querySelectorAll('input[name^="updates["]');
    if (!champs.length) return null;
    var lignes = [];
    for (var i = 0; i < champs.length; i++) {
      var cle = champs[i].name.slice(champs[i].name.indexOf('[') + 1, champs[i].name.lastIndexOf(']'));
      var variante = cle.split(':')[0];
      var quantite = parseInt(champs[i].value, 10);
      if (!variante || isNaN(quantite) || quantite < 1) continue;
      lignes.push({ variantId: variante, quantite: quantite });
    }
    return lignes;
  };

  var empreintesCourantes = function () {
    var out = {};
    var racines = document.querySelectorAll('[data-cart-promo]');
    for (var i = 0; i < racines.length; i++) {
      var sel = racines[i].dataset.form;
      out[sel] = empreinte(document.querySelector(sel));
    }
    return out;
  };

  var euros = function (cents) {
    try {
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' \u20ac';
    }
  };

  var dire = function (racine, texte, etat) {
    var msg = racine.querySelector('[data-cart-promo-msg]');
    if (!msg) return;
    msg.textContent = texte || '';
    if (etat) { msg.setAttribute('data-state', etat); } else { msg.removeAttribute('data-state'); }
  };

  var effacer = function (racine) {
    resultat = null;
    var totaux = racine && racine.querySelector('[data-cart-promo-totals]');
    if (totaux) totaux.hidden = true;
    restaurerTotal();
  };

  // Les montants affiches ailleurs que dans le bloc du code : sous-total du
  // tiroir, sous-total de la page panier, pastille de l'en-tete. Sans cela le
  // client lisait deux prix contradictoires sur le meme ecran.
  //
  // Le montant d'origine est conserve sur l'element pour pouvoir revenir en
  // arriere si le code est retire ou invalide.
  var SELECTEURS_TOTAUX = '.cart-drawer__subtotal-amount, .cart-page__subtotal-amount';

  var refleterTotal = function (data) {
    if (!data || typeof data.totalPayeCents !== 'number') return;
    var paye = euros(data.totalPayeCents);
    var officiel = euros(data.totalOfficielCents);

    var totaux = document.querySelectorAll(SELECTEURS_TOTAUX);
    for (var i = 0; i < totaux.length; i++) {
      if (typeof totaux[i].dataset.montantOrigine !== 'string') {
        totaux[i].dataset.montantOrigine = totaux[i].innerHTML;
      }
      totaux[i].innerHTML = '<s class="cart-promo__ancien">' + officiel + '</s> ' + paye;
    }

    // La pastille de l'en-tete est etroite : seul le montant a payer y tient.
    var pastilles = document.querySelectorAll('[data-cart-total]');
    for (var j = 0; j < pastilles.length; j++) {
      if (typeof pastilles[j].dataset.montantOrigine !== 'string') {
        pastilles[j].dataset.montantOrigine = pastilles[j].innerHTML;
      }
      pastilles[j].textContent = paye;
    }
  };

  var restaurerTotal = function () {
    var els = document.querySelectorAll(SELECTEURS_TOTAUX + ', [data-cart-total]');
    for (var i = 0; i < els.length; i++) {
      if (typeof els[i].dataset.montantOrigine === 'string') {
        els[i].innerHTML = els[i].dataset.montantOrigine;
        delete els[i].dataset.montantOrigine;
      }
    }
  };

  // Apres une modification du panier, le theme a deja reecrit ces montants avec
  // les valeurs fraiches du serveur. Restaurer nos anciennes valeurs y remettrait
  // un total perime : on se contente d'oublier les reperes.
  var oublierOrigines = function () {
    var els = document.querySelectorAll(SELECTEURS_TOTAUX + ', [data-cart-total]');
    for (var i = 0; i < els.length; i++) { delete els[i].dataset.montantOrigine; }
  };

  // Affichage du resultat, partage entre un calcul frais et un resultat repris
  // d'un ecran a l'autre : les deux doivent se presenter exactement pareil.
  var afficher = function (racine, data) {
    var totaux = racine.querySelector('[data-cart-promo-totals]');
    var avant = racine.querySelector('[data-cart-promo-before]');
    var apres = racine.querySelector('[data-cart-promo-after]');
    if (avant) avant.textContent = racine.dataset.labelBefore + ' ' + euros(data.totalOfficielCents);
    if (apres) apres.textContent = racine.dataset.labelAfter + ' ' + euros(data.totalPayeCents);
    if (totaux) totaux.hidden = false;

    var remisees = typeof data.lignesRemisees === 'number' ? data.lignesRemisees : 0;
    var totalLignes = typeof data.lignesTotal === 'number' ? data.lignesTotal : 0;
    if (totalLignes > 0 && remisees < totalLignes) {
      // Singulier / pluriel : « 1 article(s) ne sont pas concernes » se lisait mal.
      // Le filtre de traduction n'est pas disponible ici : les deux formes sont
      // fournies en attributs et choisies au moment de l'affichage.
      var reste = totalLignes - remisees;
      var modele = reste > 1 ? racine.dataset.msgPartialOther : racine.dataset.msgPartialOne;
      dire(racine, modele.replace('[count]', String(reste)), 'ok');
    } else {
      dire(racine, racine.dataset.msgApplied, 'ok');
    }

    refleterTotal(data);
  };

  var envoyer = function (racine, simulation) {
    var input = racine.querySelector('[data-cart-promo-input]');
    var bouton = racine.querySelector('[data-cart-promo-apply]');
    var totaux = racine.querySelector('[data-cart-promo-totals]');
    var avant = racine.querySelector('[data-cart-promo-before]');
    var apres = racine.querySelector('[data-cart-promo-after]');
    var lignesEl = racine.querySelector('[data-cart-promo-lines]');
    if (!input || !bouton || !lignesEl) return;

    var code = (input.value || '').trim();
    var lignes = lignesDepuisFormulaire(document.querySelector(racine.dataset.form));
    if (!lignes || !lignes.length) {
      // Repli sur le rendu serveur si le formulaire ne porte pas de quantites.
      try { lignes = JSON.parse(lignesEl.textContent || '[]'); } catch (e) { lignes = []; }
    }
    if (!code || !lignes.length) { dire(racine, racine.dataset.msgEmpty, 'error'); return; }

    bouton.disabled = true;
    dire(racine, '');

    // En simulation, l'ERP renvoie les memes montants mais ne cree aucun
    // brouillon de commande et ne consomme aucune utilisation du code. Reserve a
    // l'affichage : pas de lien de paiement en retour, donc rien a encaisser.
    var charge = { code: code, lignes: lignes };
    if (simulation) charge.simulation = true;

    fetch(racine.dataset.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(charge)
    })
      .then(function (r) {
        return r.json().catch(function () { return { ok: false, status: r.status }; })
          .then(function (data) { data.status = r.status; return data; });
      })
      .then(function (data) {
        bouton.disabled = false;
        if (!data || data.ok !== true || (!simulation && !data.url)) {
          effacer(racine);
          if (data && data.status === 429) { dire(racine, racine.dataset.msgRate, 'error'); return; }
          dire(racine, (data && data.error) || racine.dataset.msgError, 'error');
          return;
        }

        if (!simulation) {
          resultat = { url: data.url, empreintes: empreintesCourantes() };
          memoriser(code, data, lignes);
        }
        afficher(racine, data);
      })
      .catch(function () {
        bouton.disabled = false;
        effacer(racine);
        dire(racine, racine.dataset.msgError, 'error');
      });
  };

  // Ecouteurs delegues : ils continuent de fonctionner apres le remplacement du
  // tiroir. Des ecouteurs poses sur les elements eux-memes disparaissaient avec
  // eux, rendant le champ du tiroir muet des la premiere modification de panier.
  document.addEventListener('click', function (e) {
    var bouton = e.target.closest && e.target.closest('[data-cart-promo-apply]');
    if (!bouton) return;
    var racine = bouton.closest('[data-cart-promo]');
    if (racine) envoyer(racine);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest && e.target.closest('[data-cart-promo-input]');
    if (!input) return;
    e.preventDefault();
    var racine = input.closest('[data-cart-promo]');
    if (racine) envoyer(racine);
  });

  document.addEventListener('input', function (e) {
    var input = e.target.closest && e.target.closest('[data-cart-promo-input]');
    if (!input) return;
    // Champ vide = le client renonce a son code : ne pas le lui remettre a
    // l'ecran suivant.
    if (!(input.value || '').trim()) memoriser('');
    if (!resultat) return;
    var racine = input.closest('[data-cart-promo]');
    if (racine) { effacer(racine); dire(racine, ''); }
  });

  // Le tiroir annonce ses propres mises a jour de panier.
  // Recalcul en direct dans le tiroir. Modifier une quantite reconstruit le
  // tiroir et invalide le montant remise ; sans ce rappel, le client verrait son
  // total remise disparaitre et devrait ressaisir son code a chaque changement.
  // Temporise, pour qu'une suite de clics sur « + » ne declenche qu'un appel.
  var racineTiroir = function () {
    var racines = document.querySelectorAll('[data-cart-promo]');
    for (var i = 0; i < racines.length; i++) {
      if ((racines[i].dataset.form || '').indexOf('drawer') !== -1) return racines[i];
    }
    return null;
  };

  var minuteur = null;
  window.addEventListener('cart-updated', function () {
    resultat = null;
    oublierOrigines();
    var code = codeMemorise();
    if (!code) return;
    clearTimeout(minuteur);
    minuteur = setTimeout(function () {
      var racine = racineTiroir();
      if (!racine) return;
      var champ = racine.querySelector('[data-cart-promo-input]');
      if (!champ) return;
      if (!champ.value) champ.value = code;
      // En SIMULATION : ce rafraichissement est purement informatif, et le tiroir
      // ne mene plus au paiement mais a la page panier. Aucun brouillon de
      // commande n'est donc cree pour un montant que personne n'encaissera.
      envoyer(racine, true);
    }, 800);
  });

  // Reprise du code d'un ecran a l'autre : on le REMET dans le champ sans le
  // valider. Le valider ici creerait un brouillon de commande a chaque
  // affichage de page, y compris pour un client qui ne comptait pas s'en servir.
  var reprendre = function () {
    var o = memoire();
    if (!o) return;

    var racines = document.querySelectorAll('[data-cart-promo]');
    if (!racines.length) return;

    // Le panier a-t-il bouge depuis le calcul ? On compare le CONTENU (references
    // et quantites), pas les formulaires : le tiroir et la page panier n'ont pas
    // les memes, une comparaison de formulaire ne traverserait pas les ecrans.
    var lignesIci = null;
    for (var j = 0; j < racines.length && !lignesIci; j++) {
      lignesIci = lignesDepuisFormulaire(document.querySelector(racines[j].dataset.form));
    }
    var identique = o.signature && o.signature === signatureLignes(lignesIci);

    for (var i = 0; i < racines.length; i++) {
      var champ = racines[i].querySelector('[data-cart-promo-input]');
      if (!champ || champ.value) continue;
      champ.value = o.code;

      if (identique && o.url) {
        // Panier inchange : on retablit le montant deja calcule, tel quel. Le
        // client vient de le voir dans le tiroir, il doit le retrouver ici — et
        // sans nouvel appel, qui creerait un brouillon de commande de plus.
        resultat = { url: o.url, empreintes: empreintesCourantes() };
        afficher(racines[i], {
          totalOfficielCents: o.officiel,
          totalPayeCents: o.paye,
          lignesRemisees: o.remisees,
          lignesTotal: o.total
        });
      } else {
        // Panier modifie depuis : le montant precedent ne vaut plus rien. On se
        // contente de remettre le code, le client relance le calcul.
        dire(racines[i], racines[i].dataset.msgPrefilled, null);
      }
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reprendre);
  } else {
    reprendre();
  }

  // Redirige vers le lien remise au moment de valider la commande.
  // Le panier Shopify n'est PAS vide : si le client abandonne le paiement,
  // il retrouve ses articles.
  //
  // Renvoie true si la redirection a ete prise en charge.
  var detourner = function (form, e) {
    if (!resultat || !form || !form.querySelector) return false;
    var racine = form.querySelector('[data-cart-promo]');
    if (!racine) return false;
    var selecteur = racine.dataset.form;
    if (!form.matches(selecteur)) return false;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    var attendue = resultat.empreintes[selecteur];
    if (typeof attendue !== 'string' || attendue !== empreinte(form)) {
      effacer(racine);
      dire(racine, racine.dataset.msgStale, 'error');
      return true;
    }

    window.location.assign(resultat.url);
    return true;
  };

  // Interception au CLIC, en phase de capture. Indispensable : le script de
  // paiement de Shopify ecoute lui aussi la validation du formulaire et part
  // vers son propre paiement par navigation JavaScript. Bloquer la seule action
  // par defaut du formulaire ne l'arretait donc pas, et le client se retrouvait
  // sur le paiement plein tarif malgre le code applique — constate dans le
  // tiroir. Se placer au clic, avant tout autre ecouteur, evite cette course.
  document.addEventListener('click', function (e) {
    if (!resultat) return;
    var bouton = e.target.closest && e.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!bouton) return;
    detourner(bouton.form || bouton.closest('form'), e);
  }, true);

  // Filet pour la validation au clavier (touche Entree), qui ne passe pas
  // toujours par un clic sur le bouton.
  document.addEventListener('submit', function (e) {
    if (!resultat) return;
    var bouton = e.submitter;
    if (bouton && bouton.name && bouton.name !== 'checkout') return;
    detourner(e.target, e);
  }, true);
})();
